import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import GlobalSearch from '../../src/global_search/components/global_search';
import { QueryParamProvider } from 'use-query-params';
import CustomReactRouter7Adapter from '../../src/utilities/custom_react_router_7_adapter';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('global-search-react-app');
  if (!container) return null;
  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <BrowserRouter>
        <QueryParamProvider adapter={CustomReactRouter7Adapter}>
          <GlobalSearch />
        </QueryParamProvider>
      </BrowserRouter>
    </DevexHighOrderComponent>
  );
});
